(ns frontend.view.reports.custom.diamond-edge-ventures.report-1-total-engagement
  (:require
   [frontend.state.current-session :as session]
   [common.util :as cu]))

(def sept-1-2018 1535760000000)

(defn oppos-in-scope
  [{:keys [start-date end-date]}]
  (let [deals-pipeline-id (->> @session/pipelines
                               (cu/filter-by :pipeline/entity-type :entity.type/oppo)
                               (cu/filter-by :pipeline/name "Commercialization")
                               (first)
                               (:db/id))
        start-date-millis (if start-date (.getTime start-date) nil)
        end-date-millis (if end-date (.getTime end-date) nil)
        filtered-oppos
        (->> @session/oppos
             (cu/filter-by :oppo/pipeline deals-pipeline-id)
             (filter (fn [o]
                       (> (:common/created-on o) sept-1-2018)))
             (filter (fn [o]
                       (and
                        (if start-date-millis (>= (:common/created-on o) start-date-millis) true)
                        (if end-date-millis (<= (:common/created-on o) end-date-millis) true))))
        )]
    filtered-oppos))


(defn oppos-by-status-or-deal-type
  [filter-state]
  (let [stages-by-name (->> @session/stages
                            (map (fn [s]
                                   [(:stage/name s) s]))
                            (into {}))
        trial-with-bu-stage (:db/id (get stages-by-name "Trial with BU"))
        NDA-MTA-stage (:db/id (get stages-by-name "NDA/MTA"))
        evaluation-stage (:db/id (get stages-by-name "Evaluation"))
        partnerships-stage (:db/id (get stages-by-name "Partnership"))
        business-stage (:db/id (get stages-by-name "Business"))
        scope-stage-ids [trial-with-bu-stage NDA-MTA-stage evaluation-stage partnerships-stage
                         business-stage]
        deal-type-lookup (->> (session/named-values :oppo/tag-deal-type)
                              (map (fn [nv]
                                     [(:named-value/value nv)
                                      (:db/id nv)]))
                              (into {}))
        transfer-to-BU (get deal-type-lookup "Transfer to BU")

        BU-deal (get deal-type-lookup "BU deal")
        BU-tag-ids #{transfer-to-BU BU-deal}
        oppo-counts (cond
                      (not transfer-to-BU)
                      "'Transfer to BU' not found"
                      (not BU-deal)
                      "'BU deal' not found"

                      :else
                      (->> (oppos-in-scope @filter-state)
                           (group-by (fn [o]
                                       (cond
                                         (and (= :oppo.status/ok (:oppo/status o))
                                              (some #{(:oppo/stage o)} scope-stage-ids)
                                              (not (some BU-tag-ids (:oppo/tag-deal-type o))))
                                         :active
                                         (and (= :oppo.status/on-hold (:oppo/status o))
                                              (some #{(:oppo/stage o)} scope-stage-ids)
                                              (not (some BU-tag-ids (:oppo/tag-deal-type o))))
                                         :pending-after-engagement
                                         (and (= :oppo.status/passed (:oppo/status o))
                                              (some #{(:oppo/stage o)} scope-stage-ids)
                                              (not (some BU-tag-ids (:oppo/tag-deal-type o))))
                                         :stop-after-engagement
                                         (and (some #{transfer-to-BU} (:oppo/tag-deal-type o))
                                              (some #{:oppo.status/ok
                                                      :oppo.status/on-hold
                                                      :oppo.status/passed}
                                                    [(:oppo/status o)]))
                                         :transfer-to-bu
                                         (and (some #{BU-deal} (:oppo/tag-deal-type o))
                                              (some #{:oppo.status/ok
                                                      :oppo.status/on-hold
                                                      :oppo.status/passed}
                                                    [(:oppo/status o)]))
                                         :bu-in-charge
                                         :else
                                         nil)))
                           (keep (fn [[group deals]]
                                   (when group
                                     [group (count deals)])))
                           (into {})))]
    (if (string? oppo-counts)
      [["Error" oppo-counts]]
      (let [total-count (->> oppo-counts
                             (map second)
                             (filter number?)
                             (apply +))]
        [["Active" (get oppo-counts :active 0)]
         ["Pending After Engagement" (get oppo-counts :pending-after-engagement 0)]
         ["Stop After Engagement" (get oppo-counts :stop-after-engagement 0)]
         ["Transfer to BU" (get oppo-counts :transfer-to-bu 0)]
         ["BU in Charge" (get oppo-counts :bu-in-charge 0)]
         ["Total" total-count]]))))
